import { createSlice } from '@reduxjs/toolkit';
import extraReducers from './extra-reducer';
import reducers from './reducers';
import { initialState } from './types';

const lumiConversationSlice = createSlice({
  name: 'lumiConversation',
  initialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const { clearLuMiConversation, resetLuMiConversation, setPendingTranscriptOpen } =
  lumiConversationSlice.actions;

export default lumiConversationSlice.reducer;
